var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "close_svg__st0",
    cx: 12,
    cy: 12,
    r: 12
  })), /*#__PURE__*/React.createElement("path", {
    d: "M15.27 18.79c-.24 0-.47-.08-.66-.25l-6.53-5.79a.99.99 0 0 1-.01-1.5l6.53-5.79a.99.99 0 0 1 1.41.09c.37.41.33 1.05-.08 1.41L10.24 12l5.69 5.04c.41.37.45 1 .08 1.41-.19.22-.47.34-.74.34z",
    style: {
      fill: "#fff"
    }
  }));
};
export default SvgClose;